<template>
  <div class="com-sessionLab">
    <div class="headBox">
      <span class="headBox-title">{{Language('客户标签')}}</span>
      <span class="headBox-val">{{selectedList}}</span>
    </div>
    <div class="searchInput">
      <span style="display:inline-block;vertical-align: middle;margin-right:10px;">{{Language('搜索标签')}}</span>
      <el-cascader placeholder="" :options="optionsList" :props="props" filterable style="width: 220px;"
      @change="handleChangeFn" v-model="selectedLablist"></el-cascader>
    </div>
    <div class="cusLabelListBox">
      <el-cascader-panel v-model="selectedLablist" :options="optionsList" @change="handleChangeFn" :props="props" ref="myCascader"></el-cascader-panel>
    </div>
    <div class="btnList">
      <el-button size="mini" @click="handleComitFn(2)">{{Language('取 消')}}</el-button>
      <el-button size="mini" type="primary" @click="handleComitFn(1)">{{Language('确 定')}}</el-button>
    </div>
  </div>
</template>

<script>
import { getTreeCusLable } from "@/http/cusLableManagement";

export default {
  name: "CusLable",
  components: {},
  props: ['cusLabPath'],
  data() {
    return{
      vdnId: '',
      props: { 
        multiple: true,
        label: 'labName',
        value: 'labName'
      },
      optionsList: [],
      selectedLablist: [],
      selectedList: '',
    }
  },
  watch:{
    
  },  
  created() {
    this.vdnId = JSON.parse(LocalStorage.getItem("obj")).vdnId
    this.fetchSessionLableList()
  },
  mounted() {
    if (this.cusLabPath.length) this.formatsessLabPath()
    $(function() {
      $('.el-cascader .el-input__suffix').remove()
      $('.el-cascader .el-cascader__search-input').focus(function() {
        $('.el-cascader__dropdown .el-cascader-panel').remove()
      })
    })
  },
  methods: {
    fetchSessionLableList() {
      getTreeCusLable({
        vdnId: this.vdnId,
      }).then(res => {
        if (res && res.retCode == 1) {
          this.optionsList = this.getTreeData(res.data)
        }
      })
    },
    //剔除children空数组
    getTreeData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    //保存、取消
    handleComitFn(type) {
      let selectedIds = []
      let selectedLablist = []
      let splitlist = this.selectedList.split(';').filter(item => { return item })
      splitlist.map(item => {
        selectedLablist.push(item.split('>'))
      })
      selectedLablist.map(item => {
        var obj = this.findObjByLabname(item[0], item[item.length-1])
        selectedIds.push(obj[0].labId)
      })
      if (type==1) this.$emit('submitLabFn', type, this.selectedList, selectedIds)
      if (type==2) {
        if (this.pageType) this.$emit('submitLabFn', type)
        else this.$emit('submitLabFn', type)
      }
    },
    handleChangeFn(value) {
      this.selectedList = ''
      if (value.length) {
        value.map(item => {
          item.map((item2, index) => {
            if (item.length == (index+1)) this.selectedList += item2 + ';'
            else this.selectedList += item2 + '>'
          })
        })
      }
    },
    //标签数据回填
    formatsessLabPath() {
      this.selectedList = ''
      this.selectedLablist = []
      this.hotSelected = []
      let formatArray = []
      if (this.cusLabPath&&this.cusLabPath.length) {
        this.cusLabPath.map(item => {
          this.selectedList += item.LabPath + ';'
          formatArray.push(item.LabPath.split('>'))
        })
      }
      this.selectedLablist = formatArray
    },
    findObjByLabname(v1, v2) {
      const self = this
      var returnStr = []
      var find = function(arr, value){
        arr.forEach(item => {
          if(item.labName==value) {  
            returnStr.push(item)
          } else if(item.children) {
            find(item.children, value)                    
          }                   
        })
      }
      self.optionsList.map(item => {
        if (item.labName == v1) {
          var arry = []
          arry.push(item)
          find(arry, v2)
        }
      })
      return returnStr
    },
  }
}
</script>

<style lang="scss">
  .com-sessionLab{
    .notRight{ height: 100% }
    .el-tag--info{
      display: none !important;
    }
    .el-cascader{
      margin-top: 10px;
    }
    .el-cascader,
    .el-cascader .el-input .el-input__inner{
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input-group__append{
      padding: 0 12px;
    }
    .el-cascader-panel{
      height: 100%;
      overflow-x: auto;
    }
    .el-cascader-menu{
      min-width: 250px;
    }
    .el-cascader-menu,
    .el-scrollbar__wrap{
      height: 100%;
    }
    .el-scrollbar__wrap{
      overflow: auto;
    }
    .el-cascader-node{
      padding: 0 10px;
    }
    .cusLabelListBox{
      margin-top: 10px;
      height: calc(100% - 157px);
    }
    .labelList{
      height: 100%;
      .el-tabs__nav{
        padding: 0 !important;
      }
      .el-tabs__item{
        margin: 0 !important;
        padding: 0 !important;
        text-align: center;
        width: 80px !important;
      }
      .el-tabs__active-bar{
        margin: 0 0 0 10px !important;
        padding: 0 !important;
        text-align: center;
        width: 60px !important;
      }
      .el-tabs__content .el-tab-pane{
        height: 99% !important;
      }
      .el-checkbox.is-bordered.is-checked{
        border: 1px solid #DCDFE6;
      }
    }
    .hotLabelBox{
      height: 100%;
      overflow-y: auto;
    }
    .hotLabelItem{
      margin: 0 7px 10px 0 !important;
      width: calc(100% / 3 - 7px);
      height: auto !important;
      .el-checkbox__input,
      .el-checkbox__label{
        display: inline-block;
        vertical-align: middle;
      }
      .el-checkbox__label{
        width: calc(100% - 25px);
        span{
          display: block;
          white-space:nowrap;
          text-overflow:ellipsis;
          overflow:hidden;
        }
      }
      &:nth-child(3n) {
        margin-right: 0 !important;
      }
    }
  }
</style>
<style scoped lang="scss">
  .com-sessionLab{
    padding: 0 20px;
    height: 100%;
    .headBox{
      .headBox-title{
        display: inline-block;
        vertical-align: middle;
        width: 70px;
      }
      .headBox-val{
        border: 1px solid #ECECEC;
        text-indent: 10px;
        padding: 3px 0px;
        display: inline-block;
        vertical-align: middle;
        margin-left: -5px;
        width: calc(100% - 72px);
        min-height: 40px;
        max-height: 40px;
        overflow-y: auto;
      }
    }
    .btnList{
      padding: 20px 0 0;
      text-align: right;
    }
  }
</style>
<style>
.labelListBox .el-tabs__content{
  height: calc(100% - 55px);
}
</style>


// WEBPACK FOOTER //
// CusLable.vue?dd3c6c66